import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, LayersControl } from 'react-leaflet';
import {
  blanchCoords,
} from '../../../../constants/index';
import { Locations } from './Location';
import {
  selectAircraft,
  selectLocation
} from 'selectors/liveAircraftSelectors';
import { useSelector } from 'react-redux';

const { BaseLayer } = LayersControl;

export const AeroMap = props => {
  const [center, setCenter] = useState(blanchCoords);

  const chosenLocation = useSelector(selectLocation);
  const chosenAircraft = useSelector(selectAircraft);

  useEffect(() => {
    if (!props.mapRef.current?.leafletElement) return;
    if (chosenAircraft) {
      const map = props.mapRef.current.leafletElement;
      map.panTo([chosenAircraft?.pos?.lat, chosenAircraft?.pos?.lon]);
    } else if (chosenLocation) {
      const map = props.mapRef.current.leafletElement;
      map.panTo([
        chosenLocation?.coords?.latitude,
        chosenLocation?.coords?.longitude
      ]);
    }
    return () => {};
  }, [chosenLocation, chosenAircraft, props.mapRef]);

  return (
    <div style={{ height: 'calc(100vh - 64px)' }}>
      {props.overlay}
      <MapContainer
        className='h-full w-full'
        style={{
          zIndex: 1,
        }}
        center={blanchCoords}
        zoom={props.zoom}
        zoomControl={false}
        maxZoom={24}
        ref={props.mapRef}
        onzoomend={event => {
          const zoom = event.target.getZoom();
          props.setZoom(zoom);
        }}
        onmoveend={event => {
          const mapCenter = event.target.getCenter();
          setCenter([mapCenter.lat, mapCenter.lng]);
        }}>
        <TileLayer
          attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <TileLayer
          attribution="Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
        />
        <LayersControl>
          <BaseLayer checked name="Manna v1">
            <TileLayer
              attribution="Manna-v1"
              url="https://tiles.manna.aero/{z}/{x}/{y}.png"
              maxZoom={24}
            />
          </BaseLayer>
          <BaseLayer name="Manna v2">
            <TileLayer
              attribution="Manna-v2"
              url="https://tiles-dev.manna.aero/{z}/{x}/{y}.png"
              maxZoom={24}
            />
          </BaseLayer>
        </LayersControl>

        <Locations key="Locations" zoom={props.zoom} center={center} />
      </MapContainer>
    </div>
  );
};
